import { cloneDeep } from 'lodash-es';
import { Container, Graphics, Text } from 'pixi.js-legacy';
import { ScalableTextManager, ScalableTextOptions, } from './scalableTextManager';
import { TooltipOptions, TooltipPosition } from './tooltipManager';
export class Tooltip extends Container {
    constructor(obj, options) {
        super();
        this.background = new Graphics();
        this.visible = false;
        this.createToolTip(obj, options);
        this.addChild(this.background);
        obj
            .on('mouseover', this.onHover.bind(this))
            .on('mouseout', this.onStopHover.bind(this));
    }
    saveOptions(options = new TooltipOptions()) {
        this.options = options;
    }
    createToolTip(obj, options) {
        this.saveOptions(options);
        this.obj = obj;
        this.obj.interactive = true;
        const textOptions = new ScalableTextOptions();
        textOptions.text = this.options.text;
        textOptions.fill = this.options.textColour;
        textOptions.wordWrap = true;
        textOptions.x = this.options.padding / 2;
        textOptions.y = this.options.padding / 2;
        textOptions.wordWrapWidth = 400;
        textOptions.add = false;
        textOptions.onResize = this.update;
        this.toolTipText = ScalableTextManager.getInstance().createText(this, textOptions);
        this.draw(this.toolTipText.getCurrentScale());
    }
    draw(toolTipContent) {
        this.children
            .filter((c) => c instanceof Text)
            .map((c) => this.removeChild(c));
        this.background.clear();
        this.background.lineStyle(this.options.lineThickness, this.options.lineColour, 1);
        this.background.beginFill(this.options.fillColour, 1);
        this.background.drawRoundedRect(0, 0, toolTipContent.width + this.options.padding, toolTipContent.height + this.options.padding, this.options.cornerRadius);
        this.background.endFill();
        this.addChild(toolTipContent);
        const origin = cloneDeep(this.obj.position);
        origin.x += this.options.tierOffset.x;
        origin.y += this.options.tierOffset.y;
        switch (this.options.position) {
            case TooltipPosition.Top:
                this.x = Math.round(origin.x + (this.obj.width / 2 - this.width / 2));
                this.y = Math.round(origin.y - (this.options.positionOffset + this.height));
                break;
            case TooltipPosition.Left:
                this.x = Math.round(origin.x - (this.options.positionOffset + this.obj.width));
                this.y = Math.round(origin.y + this.obj.height / 2 - this.height / 2);
                break;
            case TooltipPosition.Right:
                this.x = Math.round(origin.x + this.obj.width + this.options.positionOffset);
                this.y = Math.round(origin.y + this.obj.height / 2 - this.height / 2);
                break;
            case TooltipPosition.Bottom:
                this.x = Math.round(origin.x + (this.obj.width / 2 - this.width / 2));
                this.y = Math.round(origin.y + this.obj.height + this.options.positionOffset);
                break;
            default:
                throw new Error('Unsupported value for tooltip position');
        }
    }
    update(text = this.toolTipText.getCurrentScale()) {
        this.draw(text);
    }
    onHover() {
        this.visible = true;
    }
    onStopHover() {
        this.visible = false;
    }
}
